import { PALETTES } from "../../themes/index.js";

export default function ThemePicker({ paletteId, onChange }) {
  return (
    <div className="stack">
      <h3>Theme</h3>
      <div className="row" style={{ flexWrap: "wrap", gap: 12 }}>
        {PALETTES.map((p) => {
          const active = p.id === paletteId;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => onChange(p.id)}
              title={p.label}
              aria-pressed={active}
              style={{
                width: 104, height: 92, borderRadius: 8, padding: 7,
                border: active ? "2px solid var(--app-accent)" : "1px solid var(--app-border)",
                background: active ? "color-mix(in srgb, var(--app-accent) 14%, var(--app-surface))" : "var(--app-surface)",
                color: "var(--app-fg)",
                display: "grid",
                gridTemplateRows: "48px 1fr",
                gap: 7,
                alignItems: "center",
              }}
            >
              <span
                aria-hidden="true"
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 6,
                  background: `linear-gradient(135deg, ${p.bg} 40%, ${p.accent})`,
                  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.12)",
                }}
              />
              <span
                style={{
                  display: "block",
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontSize: 12,
                  fontWeight: 700,
                  lineHeight: 1.15,
                  letterSpacing: 0,
                }}
              >
                {p.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
